import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';

@Component({
  selector: 'app-preshop-cidades',
  templateUrl: './preshop-cidades.component.html',
  styleUrls: ['./preshop-cidades.component.css']
})
export class PreshopCidadesComponent implements OnInit {
  hideCL: boolean = false;
  listaCidades: any[] = [];
  arrCidades: any[] = [];
  siglaUF: any = '';
  inputsearch: any = '';
  mBusca: boolean = false;
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService) { }

  ngOnInit() {
    
    // this.listaCidades.push({ Cidade: "Americana" });
    // this.listaCidades.push({ Cidade: "Campinas" });
    // this.listaCidades.push({ Cidade: "Hortolândia" });
    // this.listaCidades.push({ Cidade: "Sumaré" });
    this.tmaService.eventoFS(true);
    this.siglaUF = this.route.snapshot.paramMap.get('uf');
    this.obterCoberturaCidades();
  }

  obterCoberturaCidades() :void{
    var dadosIn = 'uf=' + this.siglaUF;
    this.tmaService.listarShopCidades(dadosIn)
    .subscribe((qRes) =>{
      this.hideCL = true;
      console.log(qRes);
      if(qRes['res'] == 'done'){
        this.listaCidades = qRes['arrCidades'];
        this.arrCidades = qRes['arrCidades'];
      }
    })
  }

  voltar() :void{
    this.router.navigate(['pre-shop/uf/'  ]);
  }

  goShop(nomeCidade :any){
    
    this.tmaService.shopUF = this.siglaUF;
    this.tmaService.shopCidade = nomeCidade;
    localStorage.removeItem("tmsGeoLoja");
    localStorage["tmsGeoLoja"] = JSON.stringify({ uf: this.siglaUF, cidade: nomeCidade });
    this.router.navigate(['/shop/' + this.siglaUF + '/' + nomeCidade.replace(/\ /g, '-')]);

  }
  digitando(textoBusca: any) :void{

    if(textoBusca !== ''){

      this.listaCidades = this.arrCidades.filter((v) =>{
        if(v.cidade.toLowerCase().indexOf(textoBusca.toLowerCase()) > -1){
          return true;
        }
      })
    }
    else{
      this.listaCidades = this.arrCidades;
    }
  }
}

